<template>

    <div class="OOP-today OOP-carousel__live" v-if="matches.length > 0">

        <carousel
            :flag       = "flagPath"
            :assoc      = "type"
            :detail     = "detail"
            :matches    = "matches"
            :class_name = "class_name"
            mode        = "live">
        </carousel>

        <div class="go-more">
            <a :href="url">Visit Score Center</a>
        </div>

    </div>

</template>

<script>
    import axios from 'axios'
    import MatchCard from './MatchCard'
    import Carousel from './MatchesCarousel'

    export default {
        props: [ 'type', 'flag', 'detail', 'url', 'tournament' ],
        components: {
            'carousel'   : Carousel,
            'score-card' : MatchCard,
        },
        data() {
            return {
                matches         : [],
                feed            : [],
                flagPath        : this.flag + '/assets/dist/svg/flags/',
                tournament_slug : this.tournament,
                class_name      : 'OOP-carousel__live',
            }
        },
        created: function () {

            this.getLive()

            let app = this
            setInterval(function () {
                app.getLive()
            }, 15 * 1000, app)

        },
        methods: {
            showMatch(match) {
                if (!match.detail) {
                    return false
                }

                if (match.detail.state != 'F') {
                    return true
                }
            },
            removeFinishedMatches(matches) {
                return matches.filter(function (match) {

                    return match.detail.state != 'F'

                })

            },
            removeWrongAssoc(matches) {
                if (this.type == 'wta') {
                    return matches
                }
                return matches.filter(function (match) {
                    return (match.id.startsWith('MS') || match.id.startsWith('MD') || match.id.startsWith('QS') || match.id.startsWith('QD'))
                })
            },
            getLive() {
                axios.get(`${window.feed_ip}/get/${this.type}/${this.tournament_slug}/live`).then(response => {

                    this.feed = response.data

                    // let liveMatches = this.removeFinishedMatches(response.data)
                    let liveMatches = this.removeWrongAssoc(response.data)

                    liveMatches.sort(function (a, b) {
                        return a.detail.crt - b.detail.crt
                    })

                    this.matches = liveMatches
                }).catch(function (error) {
                    console.log(error);
                });
            }
        }
    }
</script>
